// extracted by mini-css-extract-plugin
export var button = "esiaLogin-module--button--c3n2d";
export var descr = "esiaLogin-module--descr--M8Egk";
export var iconButtonRoot = "esiaLogin-module--iconButtonRoot--tKYwF";
export var logo = "esiaLogin-module--logo--ttfV3";
export var text = "esiaLogin-module--text---K9Mt";
export var title = "esiaLogin-module--title--+L5x4";
export var wrapper = "esiaLogin-module--wrapper--wuzTR";